import { Injectable, inject } from '@angular/core';
import { JsonHttpService } from '../http/json-http.service';
import { HttpParams } from '@angular/common/http';
import { ViewState } from './biz-grid-viewstate';

@Injectable({
    providedIn: 'root'
})
export class GridStateService {
    private http = inject(JsonHttpService);

    setState(key: string, state: any): void {
        sessionStorage.setItem(key, JSON.stringify(state));
    }

    getState(key: string): any {
        const state = JSON.parse(sessionStorage.getItem(key) || 'null') ?? undefined;
        return state;
    }

    removeState(key: string): void {
        sessionStorage.removeItem(key);
    }

    getViewStates(key: string): Promise<ViewState[]> {
        const options = {
            params: new HttpParams()
                .set('key', key)
                .set('includeSystemConfigurations', true)
        };
        return this.http.get('api/users/gridconfiguration/get-gridconfiguration', options).toPromise();
    }

    saveViewState(viewState: ViewState): Promise<ViewState> {
        return this.http.post('api/users/gridconfiguration/save-gridconfiguration', viewState).toPromise();
    }
}
